import { Link, useNavigate } from 'react-router-dom'
import { AppShell } from '../components/AppShell'
import { useLogout } from '../lib/api'
import { useAuth } from '../lib/auth'
import { SettingsSidebar } from './SettingsPage'

export function SettingsSecurityPage() {
  const { user } = useAuth()
  const logout = useLogout()
  const nav = useNavigate()

  return (
    <AppShell page="settings" breadcrumb={<span className="topbar__breadcrumb-current">Settings · Security</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Account</span></p>
          <h1 className="page-header__title">Security</h1>
          <p className="page-header__subtitle">Password, two-factor auth, and active sessions.</p>
        </div>
      </header>

      <div className="settings-layout">
        <SettingsSidebar active="security" />

        <div className="settings-content">
          <section className="settings-card">
            <header className="settings-card__header">
              <div className="settings-card__title-group">
                <h2 className="settings-card__title">Password</h2>
                <p className="settings-card__description">Use the email reset flow to change your password.</p>
              </div>
            </header>
            <div className="settings-card__body">
              <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)' }}>
                Account email: <strong style={{ fontFamily: 'var(--font-mono)' }}>{user?.email}</strong>
              </p>
              <div style={{ marginTop: 'var(--space-3)' }}>
                <Link to="/forgot-password" className="btn btn--secondary" style={{ textDecoration: 'none' }}>
                  Send password reset link
                </Link>
              </div>
            </div>
          </section>

          <section className="settings-card">
            <header className="settings-card__header">
              <div className="settings-card__title-group">
                <h2 className="settings-card__title">Two-factor authentication</h2>
                <p className="settings-card__description">Add an authenticator app for an extra layer of protection.</p>
              </div>
            </header>
            <div className="settings-card__body">
              <div className="coming-soon">
                <div className="coming-soon__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                    <rect x="3" y="11" width="18" height="11" rx="2" />
                    <path d="M7 11 V7 a5 5 0 0 1 10 0 v4" />
                  </svg>
                </div>
                <div>
                  <div className="coming-soon__title">TOTP setup coming soon</div>
                  <div className="coming-soon__body">
                    Authenticator app + recovery codes flow is on the roadmap. Until then, password + email verification protect your account.
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="settings-card">
            <header className="settings-card__header">
              <div className="settings-card__title-group">
                <h2 className="settings-card__title">Sign out</h2>
                <p className="settings-card__description">Ends the session on this device.</p>
              </div>
            </header>
            <div className="settings-card__body">
              <button type="button" className="btn btn--destructive" disabled={logout.isPending}
                onClick={() => { logout.mutate(undefined, { onSuccess: () => nav('/login') }) }}>
                {logout.isPending ? 'Signing out…' : 'Sign out'}
              </button>
            </div>
          </section>
        </div>
      </div>
    </AppShell>
  )
}
